<template>
  <div class="page">
    <div class="dian"></div>
    <div class="warp">
      <div class="left323">
        <div class="gongsi">
          <div class="hight">公司名称</div>
          <div class="hight">{{ arrList.companyName }}</div>
        </div>
        <div class="dian"></div>
        <div class="gongsi">
          <div class="hight">公司简介</div>
          <div class="hight2">{{ arrList.companyProfile }}</div>
        </div>
        <div class="dian"></div>
        <div class="gongsi">
          <div class="hight">统一社会信用代码</div>
          <div class="hight">{{ arrList.socialCreditCode }}</div>
        </div>
        <div class="dian"></div>
        <div class="gongsi">
          <div class="hight">公司法人</div>
          <div class="hight">{{ arrList.companyLegalPerson }}</div>
        </div>
        <h2>公司照片</h2>
        <div class="image">
          <el-image
            :src="item"
            v-for="item in arrList.companyImageValue"
            :key="item"
            :preview-src-list="arrList.companyImageValue"
            class="njk"
            alt=""
          ></el-image>
        </div>
        <h2>产品照片</h2>

        <div class="image">
          <el-image
            :src="item"
            v-for="item in arrList.companyProductImageValue"
            :key="item"
            class="njk"
            :preview-src-list="arrList.companyProductImageValue"
            alt=""
            :z-index="2000"
          ></el-image>
        </div>
      </div>
      <div class="right323">
        <h2 v-if="dlpd == 'true'">公司地址</h2>
        <p class="po" v-if="dlpd == 'true'">
          {{ arrList.areaInfo }}{{ arrList.companyAddress }}
        </p>
        <div class="box" v-if="dlpd == 'true'">
          <div
            class="map"
            id="container"
            style="width: 500px; height: 300px"
          ></div>
        </div>
        <h2>营业执照</h2>
        <div class="imagejj">
          <el-image
            class="hhhh"
            :style="dlpd != 'true' ? 'filter: blur(10px);' : 'color:red'"
            v-for="item in ttt"
            :key="item"
            :preview-src-list="ttt"
            :src="item"
          ></el-image>
        </div>
        <div class="btnm" @click="submit">我要下单</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, getCurrentInstance } from 'vue'
import { useRoute } from 'vue-router'
import { useRouter } from 'vue-router'
import AMap from 'AMap' // 引入高德地图
export default {
  setup () {
    const route = useRoute()
    const arrList = ref({})
    const ttt = ref([])
    const router = useRouter()
    const { proxy } = getCurrentInstance()
    const arr = ref([])
    const dlpd = ref(localStorage.getItem('loginFlag')) //判断用户登陆状态

    const oneList = () => {
      proxy
        .$get('/v3/seller/front/store/detail', { factoryId: route.query.vid })
        .then(res => {
          console.log('/v3/seller/front/store/detail')
          console.log('jianjie-----', res)
          arrList.value = res.data
          ttt.value[0] = res.data.businessLicenseImageValue
          console.log(ttt.value)
          // console.log(res);
          arr.value[0] = res.data.longitude + ''
          arr.value[1] = res.data.latitude + ''

          test()
        })
    }
    //发布询价询价
    const submit = () => {
      router.push({
        path: `/member/xuenjia/fabuxuenjia`,
        query: {
          isAppointFactory: 2,
          name: arrList.value.companyName
        }
      })
    }
    const test = () => {
      var map = new AMap.Map('container', {
        resizeEnable: true,
        center: arr.value
      })
      // var toolbar = new AMap.Toolbar( {
      //      visible:false
      // });
      map.plugin('AMap.Geolocation', function () {
        var geolocation = new AMap.Geolocation({
          // 是否使用高精度定位，默认：true
          enableHighAccuracy: true,
          showButton: false,
          // 设置定位超时时间，默认：无穷大
          timeout: 10000
        })
        map.addControl(geolocation)
        // map.addControl(toolbar)

        AMap.event.addListener(geolocation, 'complete', onComplete)
        AMap.event.addListener(geolocation, 'error', onError)
        koMap(map)
        function onComplete (data) {
          console.log(data)
          // data是具体的定位信息
        }

        function onError () {
          // 定位出错
        }
      })
    }

    const koMap = map => {
      let marker = new AMap.Marker({
        icon: '', //图片ip
        imageSize: '10px',
        position: arr.value,
        offset: new AMap.Pixel(-13, -30),
        // 设置是否可以拖拽
        draggable: true,
        cursor: 'move',
        // 设置拖拽效果
        raiseOnDrag: true
      })
      marker.setMap(map)
    }

    onMounted(() => {
      oneList()
      console.log(localStorage.getItem('isFollow'), 748798798798)
    })
    return {
      arrList,
      oneList,
      submit,
      test,
      arr,
      ttt,
      dlpd
    }
  }
}
</script>

<style>
.page {
  width: 100%;
  background-color: #f2f2f2;
}
.warp {
  width: 1200px;
  /* height: 680px; */
  margin: 0 auto;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
}
.dian {
  width: 1200px;
  height: 20px;
  margin: 0 auto;
  background-color: #fff;
}
.left323 {
  width: 600px;
  /* background-color: red; */
  height: 800px;
}
.right323 {
  width: 600px;
  /* background-color: blue; */
  height: 800px;
}
.gongsi {
  width: 100%;
  /* height: 80px; */

  font-size: 20px;
  border-bottom: 2px solid red;
}
.hight {
  width: 100%;
  height: 30px;
  line-height: 30px;
  padding-left: 20px;
}
.hight2 {
  width: 100%;

  /* line-height: 30px; */
  padding-left: 20px;
  padding-bottom: 6px;
}
.image {
  width: 100%;
  height: 120px;
  /* background-color: #f4f4f4; */
  display: flex;
  margin-top: 15px;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.njk {
  width: 90px;
  height: 90px;
  background-color: #f4f4f4;
  margin-left: 9px;
}
h2 {
  padding-left: 20px;
  margin-top: 10px;
}
.po {
  height: 30px;
  line-height: 30px;
  padding-left: 20px;
  font-size: 14px;
}
.map {
  width: 400px;
  height: 200px;
  background-color: #f2f2f2;
  margin-left: 20px;
}
.amap-wrapper {
  width: 100%;
  height: 100%;
}
.imagejj {
  width: 200px;
  height: 200px;
  background-color: #f2f2f2;
  margin-left: 20px;
  margin-top: 5px;
}
.btnm {
  width: 200px;
  height: 40px;
  background-color: red;
  line-height: 40px;
  text-align: center;
  color: #fff;
  font-weight: bold;
  margin-left: 20px;
  margin-top: 20px;
  border-radius: 7px;
}
.hhhh {
  width: 100%;
  height: 100%;
}
</style>
